import { mixpanelObject } from 'src/utils/analytics';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_WIDGET
} from 'src/utils/analytics/mixpanel/mixpanelConstants';
import { ctaEvent } from 'src/utils/analytics/mixpanel/mixpanelEventsHelper';
import { setLocalStorage } from 'src/utils/browserStorageHandler';
import { PAYMENT_JOURNEY_SOURCE } from 'src/utils/constants/localStorageConstants';
import { HamburgerMenuLinks } from 'src/utils/constants/RouterConstants';
import {
  CONSUMPTION_PAGE,
  CONSUMPTION_PAGE_WIDGET,
  GET_PREMIUM,
  VIEW_ALL_PLANS
} from 'src/utils/constants/stringConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import { getSpecialPriceText } from '../../../../utils/VideoPlayerUtils/Utils';
import { handleBuyClickOnBanner } from '../../consumptionBanner/helper';
import {
  buyPremiumButton,
  imageContainer,
  newSvodContainer,
  newSvodGradient,
  newSvodPopupImage,
  svodButtonContainer,
  svodText,
  viewAllButton,
  wrapperDiv
} from './styles';

interface NewTvodPopupProps {
  imageURL: string;
}

const NewTvodPopup = ({ imageURL }: NewTvodPopupProps) => {
  const { translations, remoteConfig } = useAppStore();
  const { NEW_CONSUMPTION_BANNER } = translations?.consumption || {};

  const {
    VIEW_ALL_PLANS: viewAllPlansText = '',
    GET_PREMIUM: getPremiumText = '',
    NEW_SVOD_BANNER_PRICE_TEXT = ''
  } = NEW_CONSUMPTION_BANNER;
  const headText = getSpecialPriceText(NEW_SVOD_BANNER_PRICE_TEXT);

  const handleViewAllPlansClick = () => {
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_WIDGET;
    mixpanelObject[MIXPANEL_PAGE_NAME] = CONSUMPTION_PAGE;
    mixpanelObject[MIXPANEL_ELEMENT] = VIEW_ALL_PLANS;
    ctaEvent();
    // setting for payment papge
    setLocalStorage(PAYMENT_JOURNEY_SOURCE, CONSUMPTION_PAGE_WIDGET);
    window.location.assign(HamburgerMenuLinks.BUY_PLAN);
  };

  const handleGetPremiumClick = () => {
    setLocalStorage(PAYMENT_JOURNEY_SOURCE, CONSUMPTION_PAGE_WIDGET);
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_WIDGET;
    mixpanelObject[MIXPANEL_PAGE_NAME] = CONSUMPTION_PAGE;
    mixpanelObject[MIXPANEL_ELEMENT] = GET_PREMIUM;
    ctaEvent();
    handleBuyClickOnBanner(remoteConfig);
  };

  return (
    <div css={newSvodContainer}>
      <div css={imageContainer}>
        <img css={newSvodPopupImage} src={imageURL} alt="player-popup" />
      </div>
      <div css={newSvodGradient} />
      <div css={wrapperDiv}>
        <div css={svodText}>{headText}</div>
        <div css={svodButtonContainer}>
          <button css={viewAllButton} onClick={handleViewAllPlansClick}>
            {viewAllPlansText}
          </button>
          <button css={buyPremiumButton} onClick={handleGetPremiumClick}>
            {getPremiumText}
          </button>
        </div>
      </div>
    </div>
  );
};
export default NewTvodPopup;
